var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConflictReviewChevronWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M3.73966 1.20041C3.43613 1.48226 3.41856 1.95681 3.70041 2.26034L7.22652 6L3.70041 9.73967C3.41856 10.0432 3.43613 10.5177 3.73967 10.7996C4.0432 11.0815 4.51775 11.0639 4.7996 10.7603L8.7996 6.51034C9.0668 6.22258 9.0668 5.77743 8.7996 5.48966L4.7996 1.23966C4.51775 0.936132 4.0432 0.918556 3.73966 1.20041Z",
    fill: "#8B4409"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConflictReviewChevronWarn);
export default __webpack_public_path__ + "static/media/conflict-review-chevron-warn.a3ba157a1f800970d45651377669bb0b.svg";
export { ForwardRef as ReactComponent };